// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--EUSx52u2TTggWjKf","inputsWrapper":"inputs-wrapper--MWyNMQb5KDAXRh1N"};